module.exports = __webpack_public_path__ + "img/visa.ac822956.png";